import React from "react";
import { useSelector } from "react-redux";

import { PENDING } from "../../config/types";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function ApiStateLoader() {
  const { status } = useSelector(({ responseStatus }) => responseStatus);

  return (
    <Backdrop
      open={status === PENDING}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <CircularProgress color="warning" />
    </Backdrop>
  );
}

export default ApiStateLoader;
